import React, { FC, useCallback } from 'react'
import { Button } from '@wmgtech/legato'
import { useNavigate } from 'react-router-dom'

import './LabelsHeader.scss'
import { Can } from 'shared/abilities'

const LabelsHeader: FC = () => {
  const navigate = useNavigate()

  const onCreateLabel = useCallback(() => {
    navigate('/admin/labels/new')
  }, [navigate])

  return (
    <Can I={'create'} a={'Zone'}>
      <Button
        className="labels-header__button"
        label="Create New Zone"
        colorType="secondary-black"
        containerStyle="outline"
        secondaryIcon="plus"
        onClick={onCreateLabel}
      />
    </Can>
  )
}

export default LabelsHeader
